import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { ChoiceExam } from "../ChoiceExam/index";
import { isEmpty } from "@/libs/tools";
import { ExamScore } from "../ExamScore/index";
import { FillBlankExam } from "../FillBlankExam/index";
import { ExamNumbers } from "../ExamNumbers/index";
import { ChoiceResult } from "../ChoiceResult/index";
@Component({
    name: "ExamText",
    components: {
        ChoiceExam,
        ExamScore,
        FillBlankExam,
        ExamNumbers,
        ChoiceResult
    }
})
export default class ExamText extends Vue {
    @Prop() private examDetail: any;
    @Prop() private exam: any;
    @Prop() private item: any;
    private questionsLen: number = 10;
    private progressList: Array<any> = [];
    @Watch("exam")
    getLen() {
        this.questionsLen = this.exam.questions.length;
        // 重复查看提示框 清空数组
        this.progressList = [];
        this.exam.questions.forEach((item, num) => {
            if (item.userAnswer === null) {
                this.progressList = [];
            } else {
                this.progressList.push(num);
            }
        });
    }

    //handelUserAnswer
    handlerChoiceClick({ num, answer, endTime }) {
        this.exam.questions[num].userAnswer = answer;
        if (isEmpty(this.exam.questions[num].startTime)) {
            this.exam.questions[num].startTime = this.examDetail.tempTime;
        }
        this.exam.questions[num].endTime = endTime;
        this.examDetail.tempTime = endTime;
        if (!(this.progressList.indexOf(num) > -1)) {
            this.progressList.push(num);
        }
    }

    handleShowSocreClick() {
        this.examDetail.showScore = true;
    }

    @Emit()
    handleExamRefresh() {}
    @Emit()
    nextSectionClick() {}
}

//@ts-ignore
export { default as ExamText } from "./index.vue";
